import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { SymbolGroupParam } from '../_helpers/symbolGroupSearchParam';
import { SymbolGroupsAction } from '../symbolGroups.action';

export const clearSelectSymbolGroupEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(SymbolGroupsAction.clearSelect),
  map(() => RouterAction.removeParam(SymbolGroupParam.name)),
);
